// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__V9zQU","card__icon":"style_card__icon__lu68v","card__title":"style_card__title___r5MR","card__description":"style_card__description__9fHQu"};